snt-source-list {
    .spacings {
        @include layout();
    }
    
    span.expand-icon {
        display: inline-block;
        height: 16px;
        width: 16px;
        position: relative;
        top: 1px;
        margin-right: 10px;
    }

    button  {
        position: relative;
        font-size: 14px;
        font-family: inherit;
        border: 0;
        padding: 0;
        background-color: inherit;
    }

    button:hover {
        text-decoration: underline;
        color: $color-primary-accent
    }

    button:focus::after {
        box-sizing: border-box;
        border: 1px dashed $color-primary-grey;
        content: "";
        right: 100%;
        width: calc(100% + 10px);
        height: calc(100% + 4px);
        left: -5px;
        top: -2px;
        position: absolute;
    }

    button:focus {
        outline: none;
        text-decoration: underline;
        color: $color-primary-accent
    }

    .close {
        display: none;
    }

    .open {
        display: block;
    }

    .source-panel {
        padding-left: 26px;
    }

    snt-source-link:nth-child(n+1) {
        margin-top: 15px;
        margin-right: 15px;
    }
}
